import PropTypes from 'prop-types';
export var medianPriceDataProps = {
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  datasets: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    data: PropTypes.arrayOf(PropTypes.number).isRequired
  }))
};
export var unimprovedValuesProps = {
  value: PropTypes.number.isRequired,
  year: PropTypes.number.isRequired,
  formatted: PropTypes.string.isRequired
};
export var profileDataProps = {
  value: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired
};
export var occupancyDataProps = {
  value: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired
};
export var articleProps = {
  title: PropTypes.string,
  url: PropTypes.string,
  image: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
  }))
};
export var commonDefaultProps = {
  title: null,
  disableAnimation: false,
  description: null,
  unimprovedValues: null,
  layout: 'default',
  underline: false
};
export var medianStatProps = {
  unitMedianPrice: PropTypes.number,
  unitPriceYearlyDelta: PropTypes.number,
  houseMedianPrice: PropTypes.number,
  housePriceYearlyDelta: PropTypes.number
};
export default {
  suburbName: PropTypes.string.isRequired,
  medianStatistics: PropTypes.shape(medianStatProps),
  population: PropTypes.string.isRequired,
  suburbInfoLink: PropTypes.string,
  medianPriceData: PropTypes.shape(medianPriceDataProps),
  profileData: PropTypes.arrayOf(PropTypes.shape(profileDataProps)),
  occupancyData: PropTypes.arrayOf(PropTypes.shape(occupancyDataProps)),
  title: PropTypes.string,
  description: PropTypes.string,
  articles: PropTypes.arrayOf(PropTypes.shape(articleProps)),
  showSuburbInfoLink: PropTypes.bool,
  unimprovedValues: PropTypes.arrayOf(PropTypes.shape(unimprovedValuesProps)),
  layout: PropTypes.oneOf(['default', 'tabbed', 'mobile']),
  underline: PropTypes.bool
};